import HARDCODE from '../../business-const/HardCode/HardCode'

import TAMMAX from '../TamMax/TamMax'

import {
    GridItem12,
} from '../../business-components/Grid/Grid'

import formPrimeiraReuniaoPadraoList from './formPrimeiraReuniaoPadraoList'

import simNaoList from "./simNaoList"



const formPrimeiraReuniaoInvestimento90List = () => {

    const formList = [...formPrimeiraReuniaoPadraoList]
    
    formList.push(
        {
            id: 2020,
            descricao: 'Selecione os principais objetivos do planejamento financeiro:',
            default: false,
            grupoPergunta: 'OBJETIVOS',
            type: 'MultiList',
            list: [
                {
                    id: 10,
                    descricao: 'Meta de Investimento',
                    ordem: 10,
                },
                {
                    id: 20,
                    descricao: 'Viagem',
                    ordem: 20,
                },
                {
                    id: 30,
                    descricao: 'Aposentadoria',
                    ordem: 30,
                },
                {
                    id: 40,
                    descricao: 'Compra de Bens',
                    ordem: 40,
                },
                {
                    id: 50,
                    descricao: 'Sucessão',
                    ordem: 50,
                },
                {
                    id: 60,
                    descricao: 'Evento Específico',
                    ordem: 60,
                },
                {
                    id: 70,
                    descricao: 'Organização Financeira',
                    ordem: 70,
                },
            ],
            labelButtonIncluirLinha: 'Incluir Objetivo',
            multiListInformarMotivoValorPrazoComentarios: true,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2020,
        },
        {
            id: 2050,
            descricao: 'Faz o controle das entradas e saidas mensalmente?',
            default: false,
            grupoPergunta: 'GESTÃO FINANCEIRA',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2050,
        },
        {
            id: 2060,
            descricao: 'Através de qual ferramenta?',
            default: false,
            grupoPergunta: 'GESTÃO FINANCEIRA',
            type: 'String',
            tamMax: 80,
            perguntaCondicionadaSim: 2050,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2060,
        },
        {
            id: 2070,
            descricao: 'Qual a sua análise do que vem acontecendo nas suas contas mês a mês?',
            default: false,
            grupoPergunta: 'GESTÃO FINANCEIRA',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            perguntaCondicionadaSim: 2050,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2070,
        },

        {
            id: 2120,
            descricao: 'Têm dívidas?',
            default: false,
            grupoPergunta: 'DÍVIDAS',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2120,
        },
        {
            id: 2130,
            descricao: 'Como chegou nessa situação?',
            default: false,
            grupoPergunta: 'DÍVIDAS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            perguntaCondicionadaSim: 2120,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2130,
        },
        {
            id: 2140,
            descricao: 'Existe um plano de saída?',
            default: false,
            grupoPergunta: 'DÍVIDAS',
            type: 'SimNao',
            list: simNaoList,
            perguntaCondicionadaSim: 2120,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2140,
        },

        {
            id: 2220,
            descricao: 'Qual é a sua área de atuação?',
            default: false,
            grupoPergunta: 'PROFISSIONAL',
            type: 'String',
            tamMax: 80,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2220,
        },
        {
            id: 2230,
            descricao: 'Separa as contas PF/PJ?',
            default: false,
            grupoPergunta: 'PROFISSIONAL',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2230,
        },
        {
            id: 2240,
            descricao: 'Existe sazonalidade? Como lida com isso?',
            default: false,
            grupoPergunta: 'PROFISSIONAL',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2240,
        },

        {
            id: 2320,
            descricao: 'Como é feita a gestão das despesas na família: unificado ou dividido?',
            default: false,
            grupoPergunta: 'CASAIS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2320,
        },

        {
            id: 2420,
            descricao: 'Tem estratégia de milhas? Como faz?',
            default: false,
            grupoPergunta: 'VIAGENS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2420,
        },
        {
            id: 2430,
            descricao: 'Tem alguma próxima viagem programada ou em mente?',
            default: false,
            grupoPergunta: 'VIAGENS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2430,
        },

        {
            id: 2520,
            descricao: 'Como você gerencia seus investimentos?',
            default: false,
            grupoPergunta: 'INVESTIMENTOS',
            type: 'String',
            tamMax: 80,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2520,
        },
        {
            id: 2530,
            descricao: 'Esta contente com o resultado?',
            default: false,
            grupoPergunta: 'INVESTIMENTOS',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2530,
        },
        {
            id: 2540,
            descricao: 'Como é o contato com o atual gerente / assessor?',
            default: false,
            grupoPergunta: 'INVESTIMENTOS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2540,
        },

        {
            id: 2620,
            descricao: 'Pretende trocar ou comprar um novo AUTOMÓVEL? (Valor/Prazo/Modelo)',
            default: false,
            grupoPergunta: 'BENS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2620,
        },
        {
            id: 2630,
            descricao: 'Pretende comprar um novo IMÓVEL? (Valor/Prazo/Local)',
            default: false,
            grupoPergunta: 'BENS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2630,
        },
        {
            id: 2640,
            descricao: 'Pretende comprar algum outro bem?',
            default: false,
            grupoPergunta: 'BENS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2640,
        },
        {
            id: 2650,
            descricao: 'Qual a sua estratégia para aquisição dos bens?',
            default: false,
            grupoPergunta: 'BENS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2650,
        },

        {
            id: 2720,
            descricao: 'Tem Plano de Saúde?',
            default: false,
            grupoPergunta: 'RISCOS',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2720,
        },
        {
            id: 2730,
            descricao: 'Contratado via PJ/CLT/PF?',
            default: false,
            grupoPergunta: 'RISCOS',
            type: 'Radio',
            list: [
                {id: 'J', descricao: 'PJ', ordem: 10},
                {id: 'C', descricao: 'CTL', ordem: 20},
                {id: 'F', descricao: 'PF', ordem: 30},
            ],
            GridItemRadioList: GridItem12,
            perguntaCondicionadaSim: 2720,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2730,
        },
        {
            id: 2740,
            descricao: 'Quem são os participantes?',
            default: false,
            grupoPergunta: 'RISCOS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            perguntaCondicionadaSim: 2720,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2740,
        },
        {
            id: 2750,
            descricao: 'Quais são as impressões do plano atual?',
            default: false,
            grupoPergunta: 'RISCOS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            perguntaCondicionadaSim: 2720,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2750,
        },
        {
            id: 2760,
            descricao: 'Existe alguém que depende ou possa depender de você financeiramente? (Pais no futuro, filhos(as), etc)',
            default: false,
            grupoPergunta: 'RISCOS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2760,
        },
        {
            id: 2770,
            descricao: 'Possui algum seguro pessoal?',
            default: false,
            grupoPergunta: 'RISCOS',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2770,
        },

        {
            id: 2820,
            descricao: 'Como enxerga a sua aposentadoria? Algum exemplo?',
            default: false,
            grupoPergunta: 'APOSENTADORIA',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2820,
        },
        {
            id: 2830,
            descricao: 'Como você realizaria esse objetivo? Valores, prazo.',
            default: false,
            grupoPergunta: 'APOSENTADORIA',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2830,
        },
        {
            id: 2840,
            descricao: 'Contribui com INSS?',
            default: false,
            grupoPergunta: 'APOSENTADORIA',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2840,
        },
        {
            id: 2850,
            descricao: 'Considera alguma herança para esse objetivo?',
            default: false,
            grupoPergunta: 'APOSENTADORIA',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2850,
        },

        {
            id: 2920,
            descricao: 'Qual o valor em FGTS?',
            default: false,
            grupoPergunta: 'INFORMAÇÕES FINANCEIRAS',
            type: 'Valor',
            atualiza: HARDCODE.formListAtualizaRecursosFinanceiros,
            atualizaIdRecursosFinanceiros: HARDCODE.idTipoRecursoFinanceiroFgtsSaldo,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2920,
        },
        {
            id: 2930,
            descricao: 'Quais cartões de crédito utiliza?',
            default: false,
            grupoPergunta: 'INFORMAÇÕES FINANCEIRAS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2930,
        },
        {
            id: 2940,
            descricao: 'Possui pontos/milhas acumuladas? Onde?',
            default: false,
            grupoPergunta: 'INFORMAÇÕES FINANCEIRAS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2940,
        },
        {
            id: 2950,
            descricao: 'Quais bancos você possui conta?',
            default: false,
            grupoPergunta: 'INFORMAÇÕES FINANCEIRAS',
            type: 'MultiLine',
            tamMax: TAMMAX.observacao,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2950,
        },
        {
            id: 2960,
            descricao: 'Possui seguro de todos os automóveis?',
            default: false,
            grupoPergunta: 'INFORMAÇÕES FINANCEIRAS',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2960,
        },
        {
            id: 2970,
            descricao: 'Possui seguro de todos os imóveis?',
            default: false,
            grupoPergunta: 'INFORMAÇÕES FINANCEIRAS',
            type: 'SimNao',
            list: simNaoList,
            tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
            ordem: 2970,
        },
    )

    return formList
}
 
export default formPrimeiraReuniaoInvestimento90List